"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const contexts_1 = require("@App/contexts");
const address_schema_1 = require("@Entities/schemas/common/address-schema");
const MailingAddress_1 = __importDefault(require("@Fields/v2/MailingAddress"));
const MemberAddressToolTip_1 = __importDefault(require("@Scenes/RightsholderRegistrationLayout/RightsholderRegistrationForm/MemberAddressToolTip"));
const Checkbox_1 = __importDefault(require("@Components/Selectors/Checkbox"));
const react_hook_form_1 = require("react-hook-form");
const phone_number_schema_1 = require("@Entities/schemas/common/phone-number-schema");
const mobx_react_1 = require("mobx-react");
const useUserDetailsId = 'useUserDetailsId';
const RightsholderAddress = ({ address }) => {
    const { userStore } = (0, react_1.useContext)(contexts_1.StoresContext);
    const { watch, setValue } = (0, react_hook_form_1.useFormContext)();
    const memberTypeValue = watch('memberType');
    const disableUseExistingCheckbox = (0, react_1.useMemo)(() => memberTypeValue === 'CMO' || memberTypeValue === 'Publisher', [memberTypeValue]);
    const useUserDetails = (checkboxState, id) => {
        if (checkboxState && useUserDetailsId === id) {
            const { email, streetAddress, city, state, country, postalCode, phoneCountryCode, phoneAreaCode, phoneNumber, } = userStore.userInfo;
            setValue('email', email);
            setValue(address_schema_1.addressFormKey, {
                streetAddress: streetAddress,
                city: city,
                state: state || '',
                countryId: country ? String(country) : '',
                postalCode: postalCode || '',
            });
            setValue(phone_number_schema_1.phoneNumberFormKey, {
                phoneCountryCode: String(phoneCountryCode),
                phoneAreaCode: phoneAreaCode || '',
                phoneNumber: phoneNumber,
            });
        }
    };
    return (react_1.default.createElement(MailingAddress_1.default, { addressFormFields: address, title: 'Member Address', toolTip: react_1.default.createElement(MemberAddressToolTip_1.default, null), subSection: react_1.default.createElement(Checkbox_1.default, { disabled: disableUseExistingCheckbox, mainColor: true, id: useUserDetailsId, onClick: useUserDetails, text: 'Use my existing user account details' }) }));
};
exports.default = (0, mobx_react_1.observer)(RightsholderAddress);
